import React from 'react';
import css from './action-button.module.css';

export default function ActionContainer({
  children,
}: React.PropsWithChildren<{}>) {
  return <div className={css['container']}>{children}</div>;
}
